(function() {
  // === OPTIMISATION 1 : Lazy Loading différé ===
  // Retarder le chargement des scripts non critiques
  
  function optimizeLazyLoading() {
    // Convertir les scripts lazyJs en scripts normaux après interaction
    let scriptsActivated = false;
    
    function activateScripts() {
      if (scriptsActivated) return;
      scriptsActivated = true;
      
      document.querySelectorAll('script[type="lazyJs"]').forEach(script => {
        const newScript = document.createElement('script');
        
        // Copier les attributs
        if (script.getAttribute('data-src')) {
          newScript.src = script.getAttribute('data-src');
        } else {
          newScript.textContent = script.textContent;
        }
        
        if (script.getAttribute('data-appco-type') === 'module') {
          newScript.type = 'module';
        }
        
        script.parentNode.replaceChild(newScript, script);
      });
      
      // Déclencher l'événement custom pour les scripts qui l'attendent
      window.dispatchEvent(new Event('appco-DOMContentLoaded'));
    }
    
    // Activer après 2 secondes ou à la première interaction
    setTimeout(activateScripts, 2000);
    ['scroll', 'click', 'touchstart'].forEach(event => {
      document.addEventListener(event, activateScripts, { once: true, passive: true });
    });
  }
  
  // === OPTIMISATION 2 : Préchargement des images critiques ===
  
  function preloadCriticalImages() {
    // Précharger la première image produit
    const firstProductImage = document.querySelector('.product-single__media img, .product__main-photos img');
    if (firstProductImage && firstProductImage.dataset.src) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = firstProductImage.dataset.src || firstProductImage.src;
      document.head.appendChild(link);
    }
  }
  
  // === OPTIMISATION 3 : Réduction des reflows CSS ===
  
  function injectPerformanceCSS() {
    const perfStyle = document.createElement('style');
    perfStyle.textContent = `
      /* Réserver l'espace pour éviter les sauts de mise en page */
      .product-single__meta {
        min-height: 300px;
      }
      
      .product-single__photos {
        min-height: 500px;
      }
      
      /* Optimiser les animations */
      * {
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
      }
      
      /* Désactiver temporairement les transitions au chargement */
      .loading-optimized * {
        transition: none !important;
        animation: none !important;
      }
      
      /* Optimiser le rendu des sélecteurs */
      select, input[type="radio"] {
        will-change: auto;
      }
      
      /* Masquer Swym Wishlist pendant le chargement */
      .swym-button:not(.swym-loaded) {
        visibility: hidden;
      }
      
      /* Stabiliser Judge.me badge */
      .jdgm-widget {
        min-height: 20px;
      }
      
      /* Éviter le layout shift du prix */
      .product__price {
        min-height: 30px;
      }
      
      /* Optimiser les images du carousel */
      .product__thumb {
        contain: layout;
      }
    `;
    document.head.appendChild(perfStyle);
    
    // Ajouter la classe loading au body
    document.body.classList.add('loading-optimized');
    
    // Retirer après le chargement
    window.addEventListener('load', () => {
      setTimeout(() => {
        document.body.classList.remove('loading-optimized');
      }, 300);
    });
  }
  
  // === OPTIMISATION 4 : Désactiver les observateurs inutiles ===
  
  function optimizeObservers() {
    // Retarder l'initialisation d'AOS (Animate On Scroll) si présent
    if (window.AOS) {
      window.AOS.init({
        startEvent: 'load',
        once: true,
        duration: 400
      });
    }
  }
  
  // === OPTIMISATION 5 : Cache des sélecteurs fréquents ===
  
  window.shopifyOptimizationCache = {
    getProductForm: function() {
      if (!this._productForm) {
        this._productForm = document.querySelector('.product-single__meta');
      }
      return this._productForm;
    },
    
    getVariantSelects: function() {
      if (!this._variantSelects) {
        this._variantSelects = document.querySelectorAll('select[data-index]');
      }
      return this._variantSelects;
    }
  };
  
  // === OPTIMISATION 6 : Debounce des événements ===
  
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  // Optimiser les événements de resize
  const optimizedResize = debounce(function() {
    // Code de resize si nécessaire
  }, 250);
  
  window.addEventListener('resize', optimizedResize, { passive: true });
  
  // === OPTIMISATION 7 : Nettoyage des console.log ===
  
  if (!window.location.href.includes('?debug')) {
    console.log = function() {};
    console.info = function() {};
    console.warn = function() {};
  }
  
  // === INITIALISATION ===
  
  function init() {
    injectPerformanceCSS();
    preloadCriticalImages();
    optimizeLazyLoading();
    optimizeObservers();
  }
  
  // Démarrer immédiatement les optimisations critiques
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();